import { render, staticRenderFns } from "./TvStations.vue?vue&type=template&id=b60e5a28"
import script from "./TvStations.vue?vue&type=script&lang=js"
export * from "./TvStations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports